<template>
  <div>
    <v-navigation-drawer app fixed clipped v-model="drawer">
      <v-list>
        <v-list-tile
          v-for="item in items"
          :key="item.title"
          @click.stop
          :to="{ path: item.path }"
          v-show="showLink(item)"
        >
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left dark color="primary">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="headline text-uppercase">
        <span class="font-weight-light">NDLM Portal</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu
        v-model="center_menu"
        :close-on-content-click="false"
        :nudge-width="300"
        max-width="300"
        bottom
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-toolbar-title v-on="on">
            <span>{{ current_center }}</span>
          </v-toolbar-title>
        </template>
      </v-menu>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        bottom
        offset-y
      >
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>person</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <img
                  src="./assets/nirmaan_trans_logo.png"
                  width="50"
                  alt="Center Manager"
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>{{
                  this.login_details.user
                }}</v-list-tile-title>
                <v-list-tile-sub-title>Center Manager</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="signout">SIGN OUT</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-container>
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </v-container>
    </v-content>
    <v-footer app dark color="primary">
      <v-layout justify-center row wrap>
        <span class="pa-2">Copyright www.nirmaan.org &copy; 2019</span>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import dbStore from "./db/dbStore";
import { mapMutations } from "vuex";
export default {
  name: "Main",
  created() {
    //this.getCenters()
    this.current_center = this.login_details.center
  },
  data() {
    return {
      drawer: true,
      menu: false,
      center_menu: false,
      //#TODO move these into config
      items: [
        {
          title: "Batches",
          path: "/main/batches"
        },
        {
          title: "Attendance",
          path: "/main/attendance"
        },
        {
          title: "Approvals",
          path: "/main/approvals",
          access: "donor"
        },
        {
          title: "Tests",
          path: "/main/tests"
        },
        {
          title: "Reports",
          path: "/main/reports"
        },
        {
          title: "About",
          path: "/main/about"
        }
      ],
      centers: null,
      current_center: ""
    };
  },
  computed: {
    login_details: function() {
      return this.$store.getters.get_login_details;
    }
  },
  methods: {
    signout: function() {
      this.menu = false;
      this.$router.push({ name: "Signout" });
    },
    showLink: function(item) {
      var show = true;
      //#TODO change to enums
      if (item.access == "donor") {
        var userInfo = this.login_details;
        if (item.access == userInfo.role) {
          show = true;
        } else {
          show = false;
        }
      }
      return show;
    },
    async getCenters() {
      dbStore.setCollectionName("centers");
      this.centers = await dbStore.getItems();
      var userDetails = this.login_details
      var user = userDetails.user
      this.centers.forEach(center => {
        var centerManagerObject = center.center_manager
        var ccenterManagerEmail = centerManagerObject.email
        if(ccenterManagerEmail === user) {
          this.current_center = center.name;
        }
      });
    },
    ...mapMutations([
      "_login_details"
    ])
  }
};
</script>
